const NOOP = ''

export default function deline(line) {
  if (typeof line === 'string') {
    return line
      .replace(/\s*\n\s*/g, ' ')
      .replace(/^\s+/, '')
      .replace(/\s+$/, '')
  } else {
    return NOOP
  }
}
